import React from 'react'

import { getClassName } from '../../utils/getClassName'
import * as Styled from './styles'

export type FormLabelProps = {
  children?: React.ReactNode
  name?: string
  onClick?: () => void
  required?: boolean | string
}

export const FormLabel = ({ children, name, required, onClick, ...rest }: FormLabelProps) => {
  if (!children) {
    return null
  }

  return (
    <Styled.FormLabel className={getClassName('label-deprecated')} htmlFor={name} onClick={onClick}>
      {children}
      {required && <span>*</span>}
    </Styled.FormLabel>
  )
}
